import type { BeforeErrorHook } from "ky";
import { isHTTPError } from "ky";

export const logBeforeError: BeforeErrorHook = async ({ error, request }) => {
  const response = isHTTPError(error) ? error.response : undefined;

  console.error({
    hook: "logResponseError",
    request: {
      method: request.method,
      path: request.url,
      body: request.body,
      headers: Object.fromEntries(request.headers.entries()),
    },
    response: {
      status: response?.status,
      headers: Object.fromEntries(response?.headers.entries() ?? []),
    },
    error: {
      name: error.name,
      message: error.message,
      stack: error.stack,
      json: JSON.stringify(error),
    },
  });

  return error;
};
